// limited prototype
// currently works only on top sticky elements

import React, { useState, useEffect, useRef } from "react";

interface Props {
  children: React.ReactNode;
  offestTop?: number;
  className?: string;
  setIsSticky?: any;
}

const StickyElement: React.FC<Props> = ({ children, className }) => {
  const [isSticky, setIsSticky] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsSticky(entry.intersectionRatio < 1);
      },
      {
        root: null,
        threshold: [1],
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return (
    <group
      data-sticky="top"
      ref={ref}
      className={`sticky ${isSticky ? className ?? "stuck" : ""}`}
    >
      {children}
    </group>
  );
};

export const StickyElementOffset: React.FC<Props> = ({ offestTop,
  children, setIsSticky, ...props }) => {
  //const [isSticky, setIsSticky] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  

  useEffect(() => {
    const checkOffsetTop = () => {
      const currentOffsetTop = ref.current?.offsetTop;
        //console.log('offsetTop changed', currentOffsetTop);
        if (currentOffsetTop && offestTop && currentOffsetTop as any > offestTop as any) {
          setIsSticky(true);
        } else {
          setIsSticky(false);
        }
        // Perform actions based on the change
    }

    let timeout = null;
    if (ref.current) {
      timeout = setInterval(checkOffsetTop, 500);
    }

    
    return () => {
      if (ref.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        clearInterval(timeout as any)
      }
    };
  }, []);

  return (
    <group
      ref={ref}
      {...props}

    >
      {children}
    </group>
  );
};

export default StickyElement;
